export const CREATING_SUPPORT_TEMPLATE = 'Creating Support Template';
export const RETRIEVING_SUPPORT_TEMPLATE = 'Retrieving Support Template';
export const UPDATING_SUPPORT_TEMPLATE = 'Updating Support Template';
